import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Modal, Col, Row} from 'antd'
import BannerAnim, { Element, Arrow, Thumb} from 'rc-banner-anim'
import TweenOne, { TweenOneGroup } from 'rc-tween-one';
import 'rc-banner-anim/assets/index.css';
import styles from './index.less'

const BgElement = Element.BgElement;




@connect(({news})=>({
  news
}), dispatch => bindActionCreators({}, dispatch))
export default class News extends Component{
  constructor(props){
    super(props);

    this.state = {
      intShow: 0,
      prevEnter: false,
      nextEnter: false,
      thumbEnter: false,
    };
  }

  onChange(type, int) {
    if (type === 'before') {
      this.setState({
        intShow: int,
      });
    }
  }



  onMouseEnter() {
    this.setState({
      thumbEnter: true,
    });
  }

  onMouseLeave() {
    this.setState({
      thumbEnter: false,
    });
  }


  render(){
    const { newspic, newsinfo } = this.props.news;

    if (!newspic || !newsinfo){
      return ''
    }

    const thumbChildren = newspic.slice(0, 5).map((img, i) =>
      <span key={i}><i style={{ backgroundImage: `url(${img.Slidepic})` }} /></span>
    );

    return(
      <div className={styles.container}>
        <div className={styles.banner_content}>
          <BannerAnim
            // onChange={::this.onChange}
            onMouseEnter={::this.onMouseEnter}
            onMouseLeave={::this.onMouseLeave}
            autoPlay
            prefixCls="custom-arrow-thumb"
          >
            {
              newspic.slice(0, 5).map((item, index) => {
                return (
                  <Element key={index}
                           prefixCls="banner-user-elem"
                  >
                    <BgElement
                      key="bg"
                      className="bg"
                      onClick={()=>{window.open(item.Slideurl)}}
                      style={{
                        backgroundImage: `url(${item.Slidepic})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        height: '100%',
                        cursor: 'pointer',
                      }}
                    />

                    <TweenOne className="banner-user-title" style={{overflow: 'hidden',whiteSpace: 'nowrap',textOverflow: 'ellipsis'}} animation={{ y: this.state.thumbEnter? -70:-30, opacity:1, type: 'to' }}>
                      {item.Slidename}
                    </TweenOne>
                  </Element>
                )
              })
            }

            <Thumb prefixCls="user-thumb" key="thumb" component={TweenOne}
                   animation={{ bottom: this.state.thumbEnter ? 0 : -70 }}
            >
              {thumbChildren}
            </Thumb>
          </BannerAnim>
        </div>
        <div className={styles.news_content}>
          <h2><span>公司新闻</span></h2>
          <ul>
            {
              newsinfo.Items.slice(0, 5).map((item, index)=>(
                <li key={index} className="clearfix">
                  <span>[{item.Inputtime.substring(5,10)}]</span>
                  <a href={`http://www.zto.cn/News/NewsDetails?id=${item.Id}`} target="_blank">{item.Title}</a>
                </li>
              ))
            }
            <li className="clearfix" style={{border: 'none'}}>
              <a href="http://www.zto.com/companyIntroduce/newList.html" target="_blank" style={{textAlign: 'center', width: '100%', color: '#b5a1a1'}}>查看更多>></a>
            </li>
          </ul>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/News/index.js